module.exports = __webpack_public_path__ + "img/wow-mobile.c8653170.png";